import { LoaderFunctionArgs } from "react-router-dom";
import {
  DirectoryProduct,
  searchDirectoryProducts,
} from "common/api/decimal/methods/samplingContent.ts";
import { getSearchQuery } from "../../query";
import { fetchSamplingProgramName } from "routes/home/common/courses/fetchSamplingProgramName.ts";

export interface SampleTitleResultsLoaderData {
  totalItems: number;
  offset: number;
  totalPages: number;
  results: DirectoryProduct[];
  programName: string | null;
  error?: string;
  hasError?: boolean;
}

export async function sampleTitleResultsLoader({
  request,
}: LoaderFunctionArgs): Promise<SampleTitleResultsLoaderData> {
  const url = new URL(request.url);
  const query = getSearchQuery(url.searchParams);
  const programNamePromise = fetchSamplingProgramName();

  if (!query) {
    const programName = await programNamePromise;
    return {
      totalItems: 0,
      offset: 0,
      totalPages: 0,
      results: [],
      programName,
    };
  }

  // Default to offset 0 and size 20 if not provided
  const offset = Number(url.searchParams.get("offset")) || 0;
  const size = Number(url.searchParams.get("size")) || 20;
  const filtersParam = url.searchParams.get("filters");
  const filters: string[] | undefined = filtersParam
    ? filtersParam.split(",").filter(Boolean)
    : undefined;

  const [response, programName] = await Promise.all([
    searchDirectoryProducts(query, size, offset, filters),
    programNamePromise,
  ]);

  // Check if the API returned an error
  if (!response.ok) {
    return {
      totalItems: 0,
      offset: 0,
      totalPages: 0,
      results: [],
      programName,
      error: response.error,
      hasError: true,
    };
  }

  return {
    totalItems: response?.meta?.page?.totals.results ?? 0,
    totalPages: response?.meta?.page?.totals.pages ?? 0,
    offset,
    results: response?.data ?? [],
    programName,
  };
}
